import { TProduct, TProductCategory } from "@/models/products.model";
import { PRODUCT_STATUS_ACTIVE, PRODUCT_STATUS_ARCHIVED } from "@icebergeradmin/common";
import axios from "@utils/axios-instance";

const getProducts = async (): Promise<TProduct[]> => {
  const response = await axios.get(`/product`);
  return response.data;
};

const saveProduct = async (
  data: Omit<TProduct, "created" | "updated" | "image"> & { image?: string }
): Promise<TProduct> => {
  // remove status from data
  const body = { ...data, status: undefined };

  const response = await axios.post(`/product`, body);
  return response.data;
};

const getCategories = async (): Promise<TProductCategory[]> => {
  const response = await axios.get("/product/categories");
  return response.data;
};

const saveCategory = async (name: string): Promise<TProductCategory & { id: number }> => {
  const response = await axios.post(`/product/categories`, { name });
  return response.data;
};

const deleteProduct = async (id: number): Promise<void> => {
  await axios.delete(`/product/${id}`);
};

const archiveProduct = async (id: number): Promise<void> => {
  await axios.patch(`/product/${id}`, { status: PRODUCT_STATUS_ARCHIVED });
};

const unarchiveProduct = async (id: number): Promise<void> => {
  await axios.patch(`/product/${id}`, { status: PRODUCT_STATUS_ACTIVE });
};

const updateProduct = async (
  id: number,
  data: Omit<TProduct, "created" | "updated" | "image"> & { image?: string }
): Promise<TProduct> => {
  const response = await axios.patch(`/product/${id}`, data);
  return response.data;
};
export default {
  getProducts,
  saveProduct,
  updateProduct,
  getCategories,
  deleteProduct,
  archiveProduct,
  unarchiveProduct,
  saveCategory,
};
